import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { theme } from "../theme/toyotaTheme";
import * as Button from "../components/Button";
import * as Type from "../globals/Type";

type ListItemValueProps = {
    hasPrice?: boolean;
    hasRemoveButton?: boolean;
};

export const Wrapper = styled.div<SpaceProps>`
    width: 100%;
    ${space};
`;

export const Header = styled.h2.attrs(() => ({
    className: "t-milli-headline",
}))`
    margin-bottom: ${theme.space[1]}px;
    font-family: ${theme.fonts.semiBold};
    font-size: 1.3rem;
    line-height: 2rem;
    text-transform: none;
    color: ${theme.colors.primaryBlack};
`;

const ListItemStyle = css`
    margin: 0;
    padding: ${theme.space[1]}px 0 12px 0;
    color: ${theme.colors.primaryBlack};
    border-bottom: 1px solid ${theme.colors.grey2};
    &:nth-child(1),
    &:nth-child(2) {
        border-top: 1px solid ${theme.colors.grey2};
    }
`;

export const DescriptionTerm = styled.dt.attrs(() => ({
    className: "t-milli-text",
}))<ListItemValueProps>`
    ${ListItemStyle};
    display: inline-block;
    width: 60%;
`;

export const DescriptionDetail = styled.dd.attrs(() => ({
    className: "t-milli-text",
}))<ListItemValueProps>`
    ${ListItemStyle};
    display: flex;
    position: relative;
    flex: 1 0 auto;
    flex-direction: ${({ hasPrice }) => (hasPrice ? "column" : "row")};
    align-items: flex-start;
    align-self: stretch;
    justify-content: flex-end;
    width: 40%;
    text-align: end;
`;

export const Content = styled.dl<ListItemValueProps>`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    margin: 12px 0;

    /* Styling for InternalLink components in the basket */
    a {
        font-size: 1.3rem;
        text-decoration: underline;
    }

    ${Button.Link} {
        /* popover */
        margin: 0 2px;
    }
`;

export const Footer = styled.div.attrs(() => ({
    className: "t-milli-text",
}))`
    margin-bottom: 0;
    color: ${theme.colors.grey7};

    ${Button.Link},
    ${Type.SmallText} {
        color: ${theme.colors.grey7};
    }
`;
